'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

/* ─── Icons ─────────────────────────────────────────────── */
const StarIcon = ({ filled }: {filled: boolean;}) =>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
  </svg>;


const CartIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
  </svg>;


const ShieldCheckIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
  </svg>;


const PrinterIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
  </svg>;


const ChevronRightIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>;


const CheckIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="h-4 w-4 text-emerald-600">
    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
  </svg>;


const TruckIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
  </svg>;


const ArrowRightIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>;


/* ─── Data ───────────────────────────────────────────────── */
interface ProductData {
  id: string;
  title: string;
  subtitle: string;
  badge: string;
  grade: string;
  gradeStyle: string;
  category: string;
  stock: string;
  stockStyle: string;
  price: string;
  comparePrice: string;
  savePct: number;
  priceColor: string;
  btnStyle: string;
  images: {src: string;alt: string;}[];
  functions: string[];
  highlights: string[];
  specs: {label: string;value: string;}[];
  reviews: {author: string;rating: number;date: string;body: string;verified: boolean;}[];
  related: {id: string;href: string;image: string;imageAlt: string;title: string;price: string;comparePrice: string;grade: string;gradeStyle: string;priceColor: string;btnStyle: string;btnHover: string;bgGradient: string;hoverBorder: string;}[];
}

const productDatabase: Record<string, ProductData> = {
  'hp-deskjet-2827e-refurbished': {
    id: 'RFP-001-DESKJET2827E',
    title: 'Refurbished HP DeskJet 2827e',
    subtitle: 'Compact home inkjet printer with wireless connectivity',
    badge: 'Refurbished',
    grade: 'Grade C',
    gradeStyle: 'bg-blue-50 text-blue-700 ring-blue-100',
    category: 'Home Inkjet',
    stock: 'In stock',
    stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
    price: '$39.00',
    comparePrice: '$79.00',
    savePct: 51,
    priceColor: 'text-blue-700',
    btnStyle: 'bg-blue-700 hover:bg-red-600 shadow-[0_12px_24px_rgba(29,78,216,0.22)]',
    images: [
    { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d06d2467-1780400384077.png", alt: 'Refurbished HP DeskJet 2827e front view' },
    { src: "https://img.rocket.new/generatedImages/rocket_gen_img_16d0a82e8-1778539459165.png", alt: 'Refurbished HP DeskJet 2827e side view' },
    { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1fac547d3-1778539459654.png", alt: 'Refurbished HP DeskJet 2827e top view' }],

    functions: ['Print', 'Scan', 'Copy'],
    highlights: [
    'Wireless & USB connectivity for flexible setup',
    'Mobile printing via HP Smart app',
    'Compact design fits any desk or shelf',
    'Quality-checked and tested before dispatch',
    'Compatible with HP 67 ink cartridges'],

    specs: [
    { label: 'Print Technology', value: 'Thermal Inkjet' },
    { label: 'Print Speed (Black)', value: 'Up to 7.5 ppm' },
    { label: 'Print Speed (Color)', value: 'Up to 5.5 ppm' },
    { label: 'Max Print Resolution', value: '4800 x 1200 dpi' },
    { label: 'Scan Resolution', value: '1200 dpi' },
    { label: 'Paper Input Capacity', value: '60 sheets' },
    { label: 'Connectivity', value: 'USB 2.0, Wi-Fi 802.11b/g/n' },
    { label: 'Mobile Printing', value: 'HP Smart App, AirPrint, Mopria' },
    { label: 'Dimensions (W×D×H)', value: '425 × 304 × 148 mm' },
    { label: 'Weight', value: '3.63 kg' },
    { label: 'Ink Cartridges', value: 'HP 67 Black & Tri-color' },
    { label: 'Condition Grade', value: 'Grade C – Functional, cosmetic wear' }],

    reviews: [
    { author: 'Sarah M.', rating: 5, date: 'March 2025', body: 'Perfect for home use. Prints clearly and the wireless setup was straightforward. Great value for the price.', verified: true },
    { author: 'James T.', rating: 4, date: 'February 2025', body: 'Works exactly as described. Minor cosmetic marks but prints beautifully. Would recommend for anyone on a budget.', verified: true },
    { author: 'Linda K.', rating: 5, date: 'January 2025', body: 'Bought this for my kids\' school projects. Fast delivery, well packaged, and prints are crisp. Very happy!', verified: true },
    { author: 'Robert P.', rating: 4, date: 'December 2024', body: 'Solid refurbished printer. Setup took 10 minutes and it connected to Wi-Fi without issues. Good buy.', verified: false }],

    related: [
    { id: 'RFP-002', href: '/products/hp-deskjet-2855e-refurbished/', image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d0a82e8-1778539459165.png", imageAlt: 'Refurbished HP DeskJet 2855e wireless inkjet printer', title: 'Refurbished HP DeskJet 2855e', price: '$42.00', comparePrice: '$89.00', grade: 'Grade B', gradeStyle: 'bg-red-50 text-red-600 ring-red-100', priceColor: 'text-red-600', btnStyle: 'bg-red-600', btnHover: 'hover:bg-blue-700', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]', hoverBorder: 'hover:border-red-300' },
    { id: 'RFP-003', href: '/products/hp-deskjet-4255e-refurbished/', image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d0a82e8-1778539459165.png", imageAlt: 'Refurbished HP DeskJet 4255e all-in-one inkjet printer', title: 'Refurbished HP DeskJet 4255e', price: '$49.00', comparePrice: '$109.00', grade: 'Grade A', gradeStyle: 'bg-blue-50 text-blue-700 ring-blue-100', priceColor: 'text-blue-700', btnStyle: 'bg-blue-700', btnHover: 'hover:bg-red-600', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(37,99,235,0.18),transparent_34%),linear-gradient(135deg,#f4f8ff_0%,#ffffff_58%,#fff7f7_100%)]', hoverBorder: 'hover:border-blue-300' },
    { id: 'RFP-004', href: '/products/hp-envy-6155e-refurbished/', image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d0a82e8-1778539459165.png", imageAlt: 'Refurbished HP Envy 6155e wireless all-in-one inkjet printer', title: 'Refurbished HP Envy 6155e', price: '$79.00', comparePrice: '$159.00', grade: 'Grade A', gradeStyle: 'bg-red-50 text-red-600 ring-red-100', priceColor: 'text-red-600', btnStyle: 'bg-red-600', btnHover: 'hover:bg-blue-700', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]', hoverBorder: 'hover:border-red-300' }]

  },
  'hp-deskjet-2855e-refurbished': {
    id: 'RFP-002-DESKJET2855E',
    title: 'Refurbished HP DeskJet 2855e',
    subtitle: 'Wireless home inkjet printer with HP+ smart features',
    badge: 'Refurbished',
    grade: 'Grade B',
    gradeStyle: 'bg-red-50 text-red-600 ring-red-100',
    category: 'Home Inkjet',
    stock: 'In stock',
    stockStyle: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
    price: '$42.00',
    comparePrice: '$89.00',
    savePct: 53,
    priceColor: 'text-red-600',
    btnStyle: 'bg-red-600 hover:bg-blue-700 shadow-[0_12px_24px_rgba(220,38,38,0.22)]',
    images: [
    { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1fac547d3-1778539459654.png", alt: 'Refurbished HP DeskJet 2855e front view' },
    { src: "https://img.rocket.new/generatedImages/rocket_gen_img_16d0a82e8-1778539459165.png", alt: 'Refurbished HP DeskJet 2855e side view' },
    { src: 'https://printhubsolution.com/_next/static/media/printer-004-optimized.a546f6bc.webp', alt: 'Refurbished HP DeskJet 2855e top view' }],

    functions: ['Print', 'Scan', 'Copy'],
    highlights: [
    'HP+ smart features with automatic updates',
    'Wireless & USB connectivity',
    'Mobile printing via HP Smart app',
    'Compact design for home and student use',
    'Quality-checked and tested before dispatch'],

    specs: [
    { label: 'Print Technology', value: 'Thermal Inkjet' },
    { label: 'Print Speed (Black)', value: 'Up to 8.5 ppm' },
    { label: 'Print Speed (Color)', value: 'Up to 5.5 ppm' },
    { label: 'Max Print Resolution', value: '4800 x 1200 dpi' },
    { label: 'Scan Resolution', value: '1200 dpi' },
    { label: 'Paper Input Capacity', value: '60 sheets' },
    { label: 'Connectivity', value: 'USB 2.0, Wi-Fi 802.11b/g/n' },
    { label: 'Mobile Printing', value: 'HP Smart App, AirPrint, Mopria' },
    { label: 'Dimensions (W×D×H)', value: '430 × 306 × 150 mm' },
    { label: 'Weight', value: '3.7 kg' },
    { label: 'Ink Cartridges', value: 'HP 67 Black & Tri-color' },
    { label: 'Condition Grade', value: 'Grade B – Good condition, minor marks' }],

    reviews: [
    { author: 'Emily R.', rating: 5, date: 'April 2025', body: 'Excellent printer for the price. HP+ features work great and the print quality is impressive.', verified: true },
    { author: 'David L.', rating: 4, date: 'March 2025', body: 'Good refurbished unit. Works perfectly, minor cosmetic scratches but nothing noticeable during use.', verified: true },
    { author: 'Anna W.', rating: 5, date: 'February 2025', body: 'Fast shipping and well packaged. Printer connected to Wi-Fi immediately. Very satisfied.', verified: false }],

    related: [
    { id: 'RFP-001', href: '/products/hp-deskjet-2827e-refurbished/', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a1336e3f-1780400384863.png", imageAlt: 'Refurbished HP DeskJet 2827e inkjet printer', title: 'Refurbished HP DeskJet 2827e', price: '$39.00', comparePrice: '$79.00', grade: 'Grade C', gradeStyle: 'bg-blue-50 text-blue-700 ring-blue-100', priceColor: 'text-blue-700', btnStyle: 'bg-blue-700', btnHover: 'hover:bg-red-600', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(37,99,235,0.18),transparent_34%),linear-gradient(135deg,#f4f8ff_0%,#ffffff_58%,#fff7f7_100%)]', hoverBorder: 'hover:border-blue-300' },
    { id: 'RFP-003', href: '/products/hp-deskjet-4255e-refurbished/', image: 'https://printhubsolution.com/_next/static/media/printer-003-optimized.a025b643.webp', imageAlt: 'Refurbished HP DeskJet 4255e all-in-one inkjet printer', title: 'Refurbished HP DeskJet 4255e', price: '$49.00', comparePrice: '$109.00', grade: 'Grade A', gradeStyle: 'bg-blue-50 text-blue-700 ring-blue-100', priceColor: 'text-blue-700', btnStyle: 'bg-blue-700', btnHover: 'hover:bg-red-600', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(37,99,235,0.18),transparent_34%),linear-gradient(135deg,#f4f8ff_0%,#ffffff_58%,#fff7f7_100%)]', hoverBorder: 'hover:border-blue-300' },
    { id: 'RFP-004', href: '/products/hp-envy-6155e-refurbished/', image: 'https://printhubsolution.com/_next/static/media/printer-004-optimized.a546f6bc.webp', imageAlt: 'Refurbished HP Envy 6155e wireless all-in-one inkjet printer', title: 'Refurbished HP Envy 6155e', price: '$79.00', comparePrice: '$159.00', grade: 'Grade A', gradeStyle: 'bg-red-50 text-red-600 ring-red-100', priceColor: 'text-red-600', btnStyle: 'bg-red-600', btnHover: 'hover:bg-blue-700', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]', hoverBorder: 'hover:border-red-300' }]

  }
};

// Default fallback product
const defaultProduct: ProductData = {
  id: 'RFP-DEFAULT',
  title: 'Refurbished HP DeskJet 4255e',
  subtitle: 'All-in-one wireless inkjet printer for home and students',
  badge: 'Refurbished',
  grade: 'Grade A',
  gradeStyle: 'bg-blue-50 text-blue-700 ring-blue-100',
  category: 'Home Inkjet',
  stock: 'Low stock',
  stockStyle: 'bg-amber-50 text-amber-700 ring-amber-100',
  price: '$49.00',
  comparePrice: '$109.00',
  savePct: 55,
  priceColor: 'text-blue-700',
  btnStyle: 'bg-blue-700 hover:bg-red-600 shadow-[0_12px_24px_rgba(29,78,216,0.22)]',
  images: [
  { src: 'https://printhubsolution.com/_next/static/media/printer-003-optimized.a025b643.webp', alt: 'Refurbished HP DeskJet 4255e front view' },
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_16d0a82e8-1778539459165.png", alt: 'Refurbished HP DeskJet 4255e side view' },
  { src: 'https://printhubsolution.com/_next/static/media/printer-002-optimized.4a646f28.webp', alt: 'Refurbished HP DeskJet 4255e top view' }],

  functions: ['Print', 'Scan', 'Copy'],
  highlights: [
  'All-in-one print, scan, and copy functionality',
  'Wireless & USB connectivity for flexible setup',
  'Mobile printing via HP Smart app',
  'Compact design fits any desk or shelf',
  'Quality-checked and tested before dispatch'],

  specs: [
  { label: 'Print Technology', value: 'Thermal Inkjet' },
  { label: 'Print Speed (Black)', value: 'Up to 8.5 ppm' },
  { label: 'Print Speed (Color)', value: 'Up to 5.5 ppm' },
  { label: 'Max Print Resolution', value: '4800 x 1200 dpi' },
  { label: 'Scan Resolution', value: '1200 dpi' },
  { label: 'Paper Input Capacity', value: '80 sheets' },
  { label: 'Connectivity', value: 'USB 2.0, Wi-Fi 802.11b/g/n' },
  { label: 'Mobile Printing', value: 'HP Smart App, AirPrint, Mopria' },
  { label: 'Dimensions (W×D×H)', value: '440 × 320 × 155 mm' },
  { label: 'Weight', value: '4.1 kg' },
  { label: 'Ink Cartridges', value: 'HP 67 Black & Tri-color' },
  { label: 'Condition Grade', value: 'Grade A – Excellent condition' }],

  reviews: [
  { author: 'Michael B.', rating: 5, date: 'May 2025', body: 'Outstanding printer for the price. Grade A condition means it looks nearly new. Print quality is excellent.', verified: true },
  { author: 'Claire S.', rating: 5, date: 'April 2025', body: 'Bought for my home office. Setup was simple and it works flawlessly. Highly recommend!', verified: true },
  { author: 'Tom H.', rating: 4, date: 'March 2025', body: 'Great value refurbished printer. Scans and copies are sharp. Minor delay on first print but otherwise perfect.', verified: true }],

  related: [
  { id: 'RFP-001', href: '/products/hp-deskjet-2827e-refurbished/', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a1336e3f-1780400384863.png", imageAlt: 'Refurbished HP DeskJet 2827e inkjet printer', title: 'Refurbished HP DeskJet 2827e', price: '$39.00', comparePrice: '$79.00', grade: 'Grade C', gradeStyle: 'bg-blue-50 text-blue-700 ring-blue-100', priceColor: 'text-blue-700', btnStyle: 'bg-blue-700', btnHover: 'hover:bg-red-600', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(37,99,235,0.18),transparent_34%),linear-gradient(135deg,#f4f8ff_0%,#ffffff_58%,#fff7f7_100%)]', hoverBorder: 'hover:border-blue-300' },
  { id: 'RFP-002', href: '/products/hp-deskjet-2855e-refurbished/', image: 'https://printhubsolution.com/_next/static/media/printer-002-optimized.4a646f28.webp', imageAlt: 'Refurbished HP DeskJet 2855e wireless inkjet printer', title: 'Refurbished HP DeskJet 2855e', price: '$42.00', comparePrice: '$89.00', grade: 'Grade B', gradeStyle: 'bg-red-50 text-red-600 ring-red-100', priceColor: 'text-red-600', btnStyle: 'bg-red-600', btnHover: 'hover:bg-blue-700', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]', hoverBorder: 'hover:border-red-300' },
  { id: 'RFP-004', href: '/products/hp-envy-6155e-refurbished/', image: 'https://printhubsolution.com/_next/static/media/printer-004-optimized.a546f6bc.webp', imageAlt: 'Refurbished HP Envy 6155e wireless all-in-one inkjet printer', title: 'Refurbished HP Envy 6155e', price: '$79.00', comparePrice: '$159.00', grade: 'Grade A', gradeStyle: 'bg-red-50 text-red-600 ring-red-100', priceColor: 'text-red-600', btnStyle: 'bg-red-600', btnHover: 'hover:bg-blue-700', bgGradient: 'bg-[radial-gradient(circle_at_18%_18%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,#fff7f7_0%,#ffffff_58%,#f8fbff_100%)]', hoverBorder: 'hover:border-red-300' }]

};

/* ─── Star Rating ────────────────────────────────────────── */
function StarRating({ rating, size = 'sm' }: {rating: number;size?: 'sm' | 'lg';}) {
  return (
    <div className={`flex items-center gap-0.5 ${size === 'lg' ? 'text-amber-400' : 'text-amber-400'}`}>
      {[1, 2, 3, 4, 5].map((i) =>
      <StarIcon key={i} filled={i <= rating} />
      )}
    </div>);

}

/* ─── Related Product Card ───────────────────────────────── */
function RelatedCard({ product }: {product: ProductData['related'][0];}) {
  return (
    <article className={`group relative overflow-hidden border border-blue-100 bg-white shadow-[0_8px_24px_rgba(15,23,42,0.07)] ring-1 ring-blue-50 transition duration-200 hover:-translate-y-0.5 hover:shadow-[0_16px_40px_rgba(15,23,42,0.12)] ${product.hoverBorder} flex flex-col rounded-[12px]`}>
      <Link href={product.href} className={`relative overflow-hidden ${product.bgGradient} h-44`}>
        <span className="absolute right-3 top-3 z-10 rounded-full bg-white px-2.5 py-1 text-[10px] font-bold text-red-600 shadow-sm ring-1 ring-red-100">
          Save {Math.round((1 - parseFloat(product.price.replace('$', '')) / parseFloat(product.comparePrice.replace('$', ''))) * 100)}%
        </span>
        <img src={product.image} alt={product.imageAlt} className="absolute inset-0 h-full w-full object-contain px-6 py-4 transition duration-300 group-hover:scale-105" />
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <span className={`inline-flex w-fit items-center gap-1 rounded-[7px] px-2.5 py-1 text-[10px] font-bold ring-1 ${product.gradeStyle}`}>
          <ShieldCheckIcon />
          {product.grade}
        </span>
        <Link href={product.href}>
          <h3 className="mt-2 text-sm font-semibold leading-snug text-slate-900 transition group-hover:text-blue-700 line-clamp-2">{product.title}</h3>
        </Link>
        <div className="mt-2 flex items-end gap-2">
          <span className={`text-lg font-bold ${product.priceColor}`}>{product.price}</span>
          <span className="pb-0.5 text-xs font-semibold text-slate-400 line-through">{product.comparePrice}</span>
        </div>
        <button type="button" className={`mt-3 inline-flex h-9 w-full items-center justify-center gap-2 rounded-[8px] text-xs font-semibold text-white transition ${product.btnStyle} ${product.btnHover}`}>
          <CartIcon />
          Add to Cart
        </button>
      </div>
    </article>);

}

/* ─── Page ───────────────────────────────────────────────── */
export default function ProductDetailPage({ params }: {params: {slug: string;};}) {
  const product = productDatabase[params.slug] ?? defaultProduct;
  const [activeImage, setActiveImage] = useState(0);
  const [activeTab, setActiveTab] = useState<'specs' | 'reviews'>('specs');
  const [quantity, setQuantity] = useState(1);

  const avgRating = product.reviews.length ?
  Math.round(product.reviews.reduce((s, r) => s + r.rating, 0) / product.reviews.length) :
  5;

  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#f4f8ff_0%,#ffffff_40%)]">
      <Navbar />

      {/* Breadcrumb */}
      <div className="border-b border-slate-100 bg-white">
        <div className="container py-3">
          <nav className="flex items-center gap-1.5 text-xs text-slate-500">
            <Link href="/" className="transition hover:text-[#b42335]">Home</Link>
            <ChevronRightIcon />
            <Link href="/" className="transition hover:text-[#b42335]">Printers</Link>
            <ChevronRightIcon />
            <span className="font-medium text-slate-800 line-clamp-1">{product.title}</span>
          </nav>
        </div>
      </div>

      {/* Main product section */}
      <div className="container py-8 lg:py-12">
        <div className="grid gap-8 lg:grid-cols-[1fr_480px] xl:grid-cols-[1fr_520px]">

          {/* Left – Image Gallery */}
          <div className="flex flex-col gap-4">
            {/* Main image */}
            <div className="relative overflow-hidden rounded-[16px] border border-blue-100 bg-[radial-gradient(circle_at_18%_18%,rgba(37,99,235,0.12),transparent_40%),linear-gradient(135deg,#f4f8ff_0%,#ffffff_60%,#fff7f7_100%)] shadow-[0_16px_48px_rgba(15,23,42,0.1)] aspect-[4/3] flex items-center justify-center">
              <span className="absolute left-4 top-4 z-10 inline-flex items-center gap-1.5 rounded-[8px] bg-blue-50 px-3 py-1.5 text-xs font-bold text-blue-700 ring-1 ring-blue-100">
                <ShieldCheckIcon />
                {product.badge}
              </span>
              <span className="absolute right-4 top-4 z-10 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-red-600 shadow-sm ring-1 ring-red-100">
                Save {product.savePct}%
              </span>
              <img
                src={product.images[activeImage]?.src}
                alt={product.images[activeImage]?.alt}
                className="h-full w-full object-contain px-10 py-8 transition duration-300" />
              
            </div>
            {/* Thumbnails */}
            <div className="flex gap-3">
              {product.images.map((img, i) =>
              <button
                key={i}
                type="button"
                onClick={() => setActiveImage(i)}
                className={`relative h-20 w-20 shrink-0 overflow-hidden rounded-[10px] border-2 bg-white transition ${activeImage === i ? 'border-[#b42335] shadow-[0_4px_12px_rgba(180,35,53,0.2)]' : 'border-slate-200 hover:border-blue-300'}`}
                aria-label={`View image ${i + 1}`}>
                
                  <img src={img.src} alt={img.alt} className="h-full w-full object-contain p-2" />
                </button>
              )}
            </div>

            {/* Trust badges */}
            <div className="grid grid-cols-3 gap-3 rounded-[12px] border border-blue-50 bg-white p-4 shadow-[0_4px_16px_rgba(15,23,42,0.06)]">
              {[
              { icon: <ShieldCheckIcon />, label: 'Quality Checked', color: 'text-emerald-600' },
              { icon: <TruckIcon />, label: 'Free Shipping', color: 'text-blue-600' },
              { icon: <PrinterIcon />, label: '30-Day Returns', color: 'text-[#b42335]' }].
              map((b) =>
              <div key={b.label} className="flex flex-col items-center gap-1.5 text-center">
                  <span className={b.color}>{b.icon}</span>
                  <span className="text-[11px] font-semibold text-slate-600">{b.label}</span>
                </div>
              )}
            </div>
          </div>

          {/* Right – Product Info */}
          <div className="flex flex-col gap-5">
            {/* Tags */}
            <div className="flex flex-wrap gap-2">
              <span className={`inline-flex items-center gap-1 rounded-[7px] px-2.5 py-1 text-[10px] font-bold ring-1 ${product.gradeStyle}`}>
                <ShieldCheckIcon />
                {product.grade}
              </span>
              <span className="inline-flex items-center gap-1 rounded-[7px] bg-blue-50 px-2.5 py-1 text-[10px] font-bold text-blue-700 ring-1 ring-blue-100">
                <PrinterIcon />
                {product.category}
              </span>
              <span className={`inline-flex items-center rounded-[7px] px-2.5 py-1 text-[11px] font-bold ring-1 ${product.stockStyle}`}>
                {product.stock}
              </span>
            </div>

            {/* Title */}
            <div>
              <h1 className="text-2xl font-bold leading-tight text-slate-950 sm:text-3xl">{product.title}</h1>
              <p className="mt-1.5 text-sm leading-6 text-slate-500">{product.subtitle}</p>
            </div>

            {/* Rating summary */}
            <div className="flex items-center gap-3">
              <StarRating rating={avgRating} size="lg" />
              <span className="text-sm font-semibold text-slate-700">{avgRating}.0</span>
              <span className="text-sm text-slate-400">({product.reviews.length} reviews)</span>
            </div>

            {/* Price */}
            <div className="flex items-end gap-4 rounded-[12px] border border-blue-50 bg-white p-4 shadow-[0_4px_16px_rgba(15,23,42,0.06)]">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Your price</p>
                <span className={`text-4xl font-bold ${product.priceColor}`}>{product.price}</span>
              </div>
              <div className="pb-1">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">RRP</p>
                <span className="text-lg font-semibold text-slate-400 line-through">{product.comparePrice}</span>
              </div>
              <div className="ml-auto self-center rounded-full bg-red-50 px-3 py-1.5 text-sm font-bold text-red-600 ring-1 ring-red-100">
                Save {product.savePct}%
              </div>
            </div>

            {/* Functions */}
            <div className="flex flex-wrap gap-2">
              {product.functions.map((fn) =>
              <span key={fn} className="inline-flex items-center gap-1.5 rounded-[8px] bg-blue-50 px-3 py-1.5 text-xs font-bold text-blue-700 ring-1 ring-blue-100">
                  <PrinterIcon />
                  {fn}
                </span>
              )}
            </div>

            {/* Highlights */}
            <ul className="space-y-2">
              {product.highlights.map((h) =>
              <li key={h} className="flex items-start gap-2.5 text-sm text-slate-600">
                  <span className="mt-0.5 shrink-0"><CheckIcon /></span>
                  {h}
                </li>
              )}
            </ul>

            {/* Quantity + Add to cart */}
            <div className="flex flex-col gap-3 pt-1">
              <div className="flex items-center gap-3">
                <span className="text-sm font-semibold text-slate-700">Qty:</span>
                <div className="flex items-center overflow-hidden rounded-[8px] border border-slate-200 bg-white">
                  <button
                    type="button"
                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                    className="flex h-10 w-10 items-center justify-center text-slate-600 transition hover:bg-slate-50 hover:text-[#b42335]"
                    aria-label="Decrease quantity">
                    
                    <span className="text-lg font-bold leading-none">−</span>
                  </button>
                  <span className="w-10 text-center text-sm font-bold text-slate-900">{quantity}</span>
                  <button
                    type="button"
                    onClick={() => setQuantity((q) => q + 1)}
                    className="flex h-10 w-10 items-center justify-center text-slate-600 transition hover:bg-slate-50 hover:text-[#b42335]"
                    aria-label="Increase quantity">
                    
                    <span className="text-lg font-bold leading-none">+</span>
                  </button>
                </div>
              </div>
              <button
                type="button"
                className={`inline-flex h-13 w-full items-center justify-center gap-2.5 rounded-[10px] px-6 text-base font-semibold text-white transition ${product.btnStyle}`}>
                
                <CartIcon />
                Add to Cart — {product.price}
              </button>
              <Link
                href="/contact"
                className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-[10px] border-2 border-[#143c67] bg-white text-sm font-semibold text-[#143c67] transition hover:border-[#b42335] hover:text-[#b42335]">
                
                Get a Quote
              </Link>
            </div>
          </div>
        </div>

        {/* Tabs – Specs & Reviews */}
        <div className="mt-12">
          <div className="flex gap-1 rounded-[10px] border border-slate-100 bg-white p-1 shadow-[0_4px_16px_rgba(15,23,42,0.06)] w-fit">
            {(['specs', 'reviews'] as const).map((tab) =>
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(tab)}
              className={`rounded-[8px] px-6 py-2.5 text-sm font-semibold capitalize transition ${activeTab === tab ? 'bg-[#b42335] text-white shadow-[0_4px_12px_rgba(180,35,53,0.25)]' : 'text-slate-600 hover:text-slate-900'}`}>
              
                {tab === 'specs' ? 'Full Specifications' : `Reviews (${product.reviews.length})`}
              </button>
            )}
          </div>

          {/* Specs Table */}
          {activeTab === 'specs' &&
          <div className="mt-5 overflow-hidden rounded-[14px] border border-blue-50 bg-white shadow-[0_8px_32px_rgba(15,23,42,0.07)]">
              <div className="border-b border-blue-50 bg-[linear-gradient(135deg,#f4f8ff,#ffffff)] px-6 py-4">
                <h2 className="text-base font-bold text-slate-900">Technical Specifications</h2>
                <p className="mt-0.5 text-xs text-slate-500">Full details for {product.title}</p>
              </div>
              <div className="divide-y divide-slate-50">
                {product.specs.map((spec, i) =>
              <div key={spec.label} className={`grid grid-cols-[200px_1fr] gap-4 px-6 py-3.5 sm:grid-cols-[240px_1fr] ${i % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`}>
                    <span className="text-sm font-semibold text-slate-500">{spec.label}</span>
                    <span className="text-sm font-medium text-slate-900">{spec.value}</span>
                  </div>
              )}
              </div>
            </div>
          }

          {/* Reviews */}
          {activeTab === 'reviews' &&
          <div className="mt-5 space-y-4">
              {/* Summary bar */}
              <div className="flex items-center gap-6 rounded-[14px] border border-blue-50 bg-white p-6 shadow-[0_8px_32px_rgba(15,23,42,0.07)]">
                <div className="flex flex-col items-center gap-1">
                  <span className="text-5xl font-bold text-slate-900">{avgRating}.0</span>
                  <StarRating rating={avgRating} size="lg" />
                  <span className="text-xs text-slate-400">{product.reviews.length} reviews</span>
                </div>
                <div className="flex-1 space-y-2">
                  {[5, 4, 3, 2, 1].map((star) => {
                  const count = product.reviews.filter((r) => r.rating === star).length;
                  const pct = product.reviews.length ? count / product.reviews.length * 100 : 0;
                  return (
                    <div key={star} className="flex items-center gap-3">
                        <span className="w-4 text-right text-xs font-semibold text-slate-500">{star}</span>
                        <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100">
                          <div className="h-full rounded-full bg-amber-400 transition-all" style={{ width: `${pct}%` }} />
                        </div>
                        <span className="w-6 text-xs text-slate-400">{count}</span>
                      </div>);

                })}
                </div>
              </div>

              {/* Review cards */}
              {product.reviews.map((review, i) =>
            <div key={i} className="rounded-[14px] border border-slate-100 bg-white p-5 shadow-[0_4px_16px_rgba(15,23,42,0.05)]">
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex items-center gap-3">
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(135deg,#143c67,#b42335)] text-sm font-bold text-white">
                        {review.author.charAt(0)}
                      </div>
                      <div>
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-bold text-slate-900">{review.author}</span>
                          {review.verified &&
                      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-700 ring-1 ring-emerald-100">
                              <CheckIcon />
                              Verified
                            </span>
                      }
                        </div>
                        <span className="text-xs text-slate-400">{review.date}</span>
                      </div>
                    </div>
                    <StarRating rating={review.rating} />
                  </div>
                  <p className="mt-3 text-sm leading-6 text-slate-600">{review.body}</p>
                </div>
            )}
            </div>
          }
        </div>

        {/* Related Products */}
        <div className="mt-14">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold text-slate-900 sm:text-2xl">You May Also Like</h2>
              <p className="mt-1 text-sm text-slate-500">Other refurbished printers customers consider</p>
            </div>
            <Link href="/" className="hidden items-center gap-1.5 text-sm font-semibold text-[#b42335] transition hover:text-[#8b1a28] sm:flex">
              View all <ArrowRightIcon />
            </Link>
          </div>
          <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {product.related.map((rel) =>
            <RelatedCard key={rel.id} product={rel} />
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>);

}